import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { IsoDateTime } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/types"
import { getIsoDateTimeNow } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/current"
import {
    CLEAR_CONSOLE_DATA,
    CONSOLE_DATA_READY,
    ONDY_PLATFORM_CHANGED,
    REMOTE_SCREENSHOT_FORM_SUBMIT_FAILURE,
    REMOTE_SCREENSHOT_FORM_SUBMIT_SUCCESS,
    REMOTE_SCREENSHOT_FORM_SUBMITTED,
} from "./actions"
import { LOG_OUT_CLICKED } from "../../layouts/header/actions"
import { ACCOUNT_SELECTED } from "../../auth/actions"

export type ConsoleState = {
    remoteScreenshot: {
        imagePollingUrl: Maybe<string>
        imageUrl: Maybe<string>
        error: Maybe<string>
    }
    lastPollingTimestamp: IsoDateTime
    data: any[]
    ondyPlatform: string | null
}

export const createDefaultState = () => ({
    remoteScreenshot: {
        imagePollingUrl: null,
        imageUrl: null,
        error: null,
    },
    lastPollingTimestamp: getIsoDateTimeNow(),
    data: [],
    ondyPlatform: null,
})
export const consoleReducer = (state: Maybe<ConsoleState> = undefined, action: Record<string, any>) => {
    if (!state) {
        return createDefaultState()
    }

    switch (action.type) {
        case LOG_OUT_CLICKED:
        case ACCOUNT_SELECTED:
            return createDefaultState()

        case REMOTE_SCREENSHOT_FORM_SUBMITTED:
            return {
                ...state,
                remoteScreenshot: {
                    imagePollingUrl: action.payload.values.imagePollingUrl,
                    imageUrl: null,
                    error: null,
                },
            }

        case REMOTE_SCREENSHOT_FORM_SUBMIT_SUCCESS:
            return {
                ...state,
                remoteScreenshot: {
                    imagePollingUrl: null,
                    imageUrl: action.payload.imageUrl,
                    error: null,
                },
            }

        case REMOTE_SCREENSHOT_FORM_SUBMIT_FAILURE:
            return {
                ...state,
                remoteScreenshot: {
                    imagePollingUrl: null,
                    imageUrl: null,
                    error: action.payload.error,
                },
            }

        case CONSOLE_DATA_READY:
            return {
                ...state,
                lastPollingTimestamp: action.payload.timestamp,
                data: [...state.data, ...action.payload.data],
            }

        case CLEAR_CONSOLE_DATA:
            return { ...state, data: [] }

        case ONDY_PLATFORM_CHANGED:
            return { ...state, ondyPlatform: action.payload.platform }

        default:
            return state
    }
}
